import { useScrollReveal } from '@/hooks/useScrollReveal';

const featuredClients = [
  {
    name: 'BP Oil Mills',
    industry: 'Manufacturing / FMCG',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20BP%20Oil%20Mills%20company%2C%20clean%20white%20background%20with%20simple%20geometric%20oil%20drop%20icon%20in%20warm%20golden%20amber%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20sleek%20modern%20corporate%20aesthetic&width=400&height=400&seq=bp-oil-mills-logo&orientation=squarish',
  },
  {
    name: 'Crayon',
    industry: 'Advertising',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Crayon%20advertising%20agency%2C%20clean%20white%20background%20with%20simple%20stylized%20crayon%20icon%20in%20vibrant%20coral%20red%20tones%2C%20creative%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20bold%20modern%20creative%20aesthetic&width=400&height=400&seq=crayon-logo&orientation=squarish',
  },
  {
    name: 'Mega Cab',
    industry: 'Transportation',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Mega%20Cab%20transportation%20company%2C%20clean%20white%20background%20with%20simple%20stylized%20car%20icon%20in%20deep%20navy%20blue%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20reliable%20modern%20mobility%20aesthetic&width=400&height=400&seq=mega-cab-logo&orientation=squarish',
  },
  {
    name: 'Hindustan Abrasives',
    industry: 'Manufacturing',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Hindustan%20Abrasives%20manufacturing%20company%2C%20clean%20white%20background%20with%20simple%20geometric%20hexagonal%20shape%20icon%20in%20dark%20steel%20gray%20tones%2C%20industrial%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20strong%20modern%20industrial%20aesthetic&width=400&height=400&seq=hindustan-abrasives-logo&orientation=squarish',
  },
  {
    name: 'IRC Group',
    industry: 'Logistics & Supply Chain',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20IRC%20Group%20logistics%20company%2C%20clean%20white%20background%20with%20simple%20interlocking%20arrow%20icon%20in%20rich%20forest%20green%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20dynamic%20modern%20supply%20chain%20aesthetic&width=400&height=400&seq=irc-group-logo&orientation=squarish',
  },
  {
    name: 'Jamna Auto',
    industry: 'Automotive Manufacturing',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Jamna%20Auto%20automotive%20company%2C%20clean%20white%20background%20with%20simple%20stylized%20leaf%20spring%20icon%20in%20bold%20crimson%20red%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20powerful%20modern%20automotive%20aesthetic&width=400&height=400&seq=jamna-auto-logo&orientation=squarish',
  },
  {
    name: 'Crystals by Riya',
    industry: 'Retail & Jewellery',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Crystals%20by%20Riya%20jewellery%20brand%2C%20clean%20white%20background%20with%20simple%20elegant%20diamond%20crystal%20icon%20in%20soft%20rose%20pink%20tones%2C%20luxurious%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20refined%20modern%20jewellery%20aesthetic&width=400&height=400&seq=crystals-by-riya-logo&orientation=squarish',
  },
  {
    name: 'Lalit Hotel',
    industry: 'Hospitality',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Lalit%20Hotel%20hospitality%20brand%2C%20clean%20white%20background%20with%20simple%20elegant%20lotus%20flower%20icon%20in%20rich%20burgundy%20maroon%20tones%2C%20luxurious%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20premium%20modern%20hospitality%20aesthetic&width=400&height=400&seq=lalit-hotel-logo&orientation=squarish',
  },
  {
    name: 'Malik Associates',
    industry: 'CA Firm',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Malik%20Associates%20chartered%20accounting%20firm%2C%20clean%20white%20background%20with%20simple%20geometric%20pillar%20icon%20in%20deep%20teal%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20trustworthy%20modern%20financial%20aesthetic&width=400&height=400&seq=malik-associates-logo&orientation=squarish',
  },
  {
    name: 'Mercurius Advisory',
    industry: 'Accounting & Advisory',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Mercurius%20Advisory%20consulting%20firm%2C%20clean%20white%20background%20with%20simple%20stylized%20winged%20caduceus%20icon%20in%20warm%20copper%20bronze%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20premium%20modern%20advisory%20aesthetic&width=400&height=400&seq=mercurius-advisory-logo&orientation=squarish',
  },
  {
    name: 'Modi Global',
    industry: 'Medical Equipments',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/aaa103dd-1cc3-4acd-a3f2-7710f9c36720_WhatsApp-Image-2026-06-05-at-1.26.02-PM.jpeg',
  },
  {
    name: 'Money Workshop',
    industry: 'Financial Services',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/7c876376-0982-49b2-88fe-9f9e207e721d_WhatsApp-Image-2026-06-05-at-1.26.02-PM-1.jpeg',
  },
  {
    name: 'Pind Bhatura',
    industry: 'Food & Beverage',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/0b85deb7-1cba-4647-954d-94986b42b194_WhatsApp-Image-2026-06-05-at-1.26.02-PM-2.jpeg',
  },
  {
    name: 'Rajkiran Travels',
    industry: 'Travel & Tourism',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/57853cee-1243-4c07-be6a-6928e45f9f39_WhatsApp-Image-2026-06-05-at-1.26.03-PM.jpeg',
  },
  {
    name: 'Ramani',
    industry: 'Industrial Automation',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/594aac43-b7ec-4829-b3d0-cab83c8c3f34_WhatsApp-Image-2026-06-05-at-1.26.03-PM-1.jpeg',
  },
  {
    name: 'Recro Kardo',
    industry: 'Architecture',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/21a55219-7925-48db-b23c-d433dbd05f4f_WhatsApp-Image-2026-06-05-at-1.26.03-PM-2.jpeg',
  },
  {
    name: 'Sukoon Solutions',
    industry: 'EV Tractors',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/bc9ae6e1-d567-4b16-a538-47b995bc407a_WhatsApp-Image-2026-06-05-at-1.26.04-PM.jpeg',
  },
  {
    name: 'UNO Minda',
    industry: 'Automotive Manufacturing',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/9d5c8a35-74c9-41a8-ba29-7735136aac5b_WhatsApp-Image-2026-06-05-at-1.26.04-PM-1.jpeg',
  },
  {
    name: 'Upkar Stationery',
    industry: 'Stationery',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/64cba640-811a-492a-a559-c55a1db9cf73_WhatsApp-Image-2026-06-05-at-1.26.04-PM-2.jpeg',
  },
  {
    name: 'Vestige',
    industry: 'Wellness Marketing',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/6a481ade-e12a-4d2d-90c4-26818239af99_WhatsApp-Image-2026-06-05-at-1.26.05-PM.jpeg',
  },
  {
    name: 'Yellow Straw',
    industry: 'Advertising',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/d6794b23-b6d5-4eb9-bb6c-4a57c03609c5_WhatsApp-Image-2026-06-05-at-1.26.05-PM-1.jpeg',
  },
  {
    name: 'Luthra Group',
    industry: 'Energy & Realty',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/fac2d295-d220-4b48-811c-932b9b487c65_WhatsApp-Image-2026-06-05-at-1.26.05-PM-2.jpeg',
  },
  {
    name: 'Infomerics Analytics',
    industry: 'Analytics & Research',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/b4d431b7-3d58-4472-a2c2-e5121a6cd465_WhatsApp-Image-2026-06-05-at-1.26.06-PM-2.jpeg',
  },
  {
    name: 'Raghunandan Money',
    industry: 'Financial Services',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/5b9e7810-8a79-4391-aabd-f6c52cbc480e_WhatsApp-Image-2026-06-05-at-1.26.06-PM.jpeg',
  },
  {
    name: 'Manifestor Hub',
    industry: 'Manifestation Services',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/af6cc842-8f5a-4010-a85f-33a8bc4ce54c_WhatsApp-Image-2026-06-05-at-1.26.06-PM-1.jpeg',
  },
  {
    name: 'Just Procure',
    industry: 'Supply Chain',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/da056b08-060f-4342-a133-238ceaeb3994_WhatsApp-Image-2026-06-05-at-1.26.07-PM.jpeg',
  },
  {
    name: 'Kingspan Jindal',
    industry: 'Construction',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/cebc7186-422a-4f1e-b746-fc2032fe37fb_WhatsApp-Image-2026-06-05-at-1.26.07-PM-1.jpeg',
  },
  {
    name: 'E Factor',
    industry: 'Events',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/3a868a23-ff03-4c97-a0ff-137703cfa862_WhatsApp-Image-2026-06-05-at-1.26.07-PM-2.jpeg',
  },
  {
    name: 'DLF',
    industry: 'Real Estate',
    logo: 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/721a14fc-99ee-42f6-bdd5-f75528a23177_WhatsApp-Image-2026-06-05-at-1.26.08-PM.jpeg',
  },
  {
    name: 'Zenith Consulting',
    industry: 'Management Consulting',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Zenith%20Consulting%20management%20firm%2C%20clean%20white%20background%20with%20simple%20geometric%20star%20peak%20icon%20in%20rich%20deep%20charcoal%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20sharp%20modern%20consulting%20aesthetic&width=400&height=400&seq=zenith-consulting-logo&orientation=squarish',
  },
  {
    name: 'Orion Logistics',
    industry: 'Logistics & Warehousing',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Orion%20Logistics%20shipping%20company%2C%20clean%20white%20background%20with%20simple%20three%20connected%20nodes%20constellation%20icon%20in%20deep%20indigo%20navy%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20dynamic%20modern%20logistics%20aesthetic&width=400&height=400&seq=orion-logistics-logo&orientation=squarish',
  },
  {
    name: 'Apex Healthcare',
    industry: 'Healthcare & Pharma',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Apex%20Healthcare%20medical%20company%2C%20clean%20white%20background%20with%20simple%20stylized%20cross%20plus%20caduceus%20icon%20in%20calm%20sage%20green%20tones%2C%20professional%20healthcare%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20trustworthy%20modern%20medical%20aesthetic&width=400&height=400&seq=apex-healthcare-logo&orientation=squarish',
  },
  {
    name: 'Prime Builders',
    industry: 'Construction & Real Estate',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Prime%20Builders%20construction%20company%2C%20clean%20white%20background%20with%20simple%20geometric%20compass%20and%20ruler%20icon%20in%20warm%20brick%20red%20tones%2C%20professional%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20solid%20modern%20construction%20aesthetic&width=400&height=400&seq=prime-builders-logo&orientation=squarish',
  },
  {
    name: 'NovaTech Systems',
    industry: 'IT & Software',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20NovaTech%20Systems%20information%20technology%20company%2C%20clean%20white%20background%20with%20simple%20geometric%20circuit%20chip%20icon%20in%20cool%20slate%20gray%20tones%2C%20professional%20tech%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20sleek%20modern%20technology%20aesthetic&width=400&height=400&seq=novatech-systems-logo&orientation=squarish',
  },
  {
    name: 'Sterling Industries',
    industry: 'Industrial Manufacturing',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Sterling%20Industries%20manufacturing%20company%2C%20clean%20white%20background%20with%20simple%20geometric%20gear%20cog%20icon%20in%20rich%20bronze%20copper%20tones%2C%20professional%20industrial%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20robust%20modern%20manufacturing%20aesthetic&width=400&height=400&seq=sterling-industries-logo&orientation=squarish',
  },
  {
    name: 'Vanguard Securities',
    industry: 'Financial Securities',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20Vanguard%20Securities%20financial%20services%20firm%2C%20clean%20white%20background%20with%20simple%20geometric%20shield%20upward%20arrow%20icon%20in%20deep%20emerald%20green%20tones%2C%20professional%20finance%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20secure%20modern%20investment%20aesthetic&width=400&height=400&seq=vanguard-securities-logo&orientation=squarish',
  },
  {
    name: 'BlueStone Capital',
    industry: 'Investment Banking',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20corporate%20logo%20for%20BlueStone%20Capital%20investment%20banking%20firm%2C%20clean%20white%20background%20with%20simple%20geometric%20diamond%20gemstone%20icon%20in%20rich%20royal%20sapphire%20blue%20tones%2C%20professional%20luxury%20brand%20identity%20design%2C%20flat%20minimal%20style%2C%20no%20text%20just%20symbol%2C%20high%20contrast%20vector%20style%2C%20premium%20modern%20finance%20aesthetic&width=400&height=400&seq=bluestone-capital-logo&orientation=squarish',
  },
];

const accentList = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-primary-100 text-primary-700',
];

export default function ClientsSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal(0.1);
  const { ref: featuredRef, isVisible: featuredVisible } = useScrollReveal(0.03);

  return (
    <section id="clients" className="relative bg-background-100 py-24 md:py-32 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 md:mb-20 transition-all duration-700 ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-bold tracking-widest uppercase mb-5">
            Our Clients
          </span>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-[1.1] max-w-3xl mx-auto">
            Trusted by{' '}
            <span className="text-accent-500 italic">200+ Organizations</span>
          </h2>
          <p className="mt-5 text-foreground-500 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            From manufacturing giants to boutique agencies — we&apos;ve earned the trust of businesses across every sector.
          </p>
        </div>

        {/* Featured clients with logos */}
        <div
          ref={featuredRef}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5 mb-12"
        >
          {featuredClients.map((client, idx) => (
            <div
              key={client.name}
              className={`group rounded-xl bg-background-50 border border-background-200 p-5 md:p-6 hover:border-primary-200 hover:-translate-y-0.5 transition-all duration-300 cursor-default ${
                featuredVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: featuredVisible ? `${idx * 50}ms` : '0ms' }}
            >
              <div className="w-full h-20 md:h-24 flex items-center justify-center mb-3 rounded-lg bg-background-50 overflow-hidden">
                <img
                  src={client.logo}
                  alt={`${client.name} logo`}
                  className="w-full h-full object-contain p-2"
                  loading="lazy"
                />
              </div>
              <p className="font-heading text-sm md:text-base font-bold text-foreground-900 text-center group-hover:text-primary-500 transition-colors leading-tight">
                {client.name}
              </p>
              <div className="flex justify-center mt-2">
                <span className={`inline-block px-2.5 py-1 rounded-full text-[10px] md:text-xs font-medium ${accentList[idx % accentList.length]}`}>
                  {client.industry}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Stats strip */}
        <div
          className={`mt-16 pt-12 border-t border-foreground-100 flex flex-wrap items-center justify-center gap-10 md:gap-16 transition-all duration-700 delay-500 ${
            featuredVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          {[
            { value: '200+', label: 'Client Partners' },
            { value: '37', label: 'Industries Served' },
            { value: '8+', label: 'Years in Business' },
            { value: '95%', label: 'Client Retention' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-primary-500">
                {stat.value}
              </div>
              <div className="text-foreground-500 text-xs md:text-sm font-medium mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}